import React from "react";

export default function DebugRow({ label, value }) {
  const display =
    value === null || value === undefined || value === ""
      ? "—"
      : String(value);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 py-2 text-sm">
      <span className="text-xs font-semibold text-slate-500">{label}</span>
      <span className="text-sm text-slate-700">{display}</span>
    </div>
  );
}
